<template>
  <div class="advantage">
    <div class="container">
      <!-- 头部 -->
      <div class="header">
        <div class="header-title">为什么选择我们</div>
        <p>匠心打造至臻品 实力打造口碑</p>
      </div>
      <div class="main">
        <ul class="row">
          <li class="col-xl-6">
            <div class="title">
              技术专长
            </div>
            <div class="desc">
              我们公司拥有一支由经验丰富的开发人员组成的技术团队，他们在多个领域具备深厚的专业知识和技术储备。无论是前端开发、后端开发、移动应用开发还是云计算等，我们都能提供高质量的解决方案。
            </div>
          </li>
          <li class="col-xl-6 active active-bg01">
            <div class="title">
              卓越的项目管理能力
            </div>
            <div class="desc">
              我们注重项目管理，拥有经验丰富的项目经理和周密的计划安排。通过合理的项目分解、任务分配和进度掌控，我们保证按时交付高质量的软件
            </div>
          </li>
          <li class="col-xl-6 active active-bg02">
            <div class="title">
              丰富的行业经验
            </div>
            <div class="desc">
              我们在多个行业积累了丰富的经验，了解不同行业的独特需求和挑战。我们能够为客户提供针对性的解决方案，并根据客户需求定制开发高度定
            </div>
          </li>
          <li class="col-xl-6">
            <div class="title">
              良好的口碑与客户满意度
            </div>
            <div class="desc">
              我们过去的客户都对我们的服务非常满意，并且给予了良好的口碑推荐。我们以客户为中心，不断努力提升客户满意度，与客户建立稳固的合作
            </div>
          </li>
          <li class="col-xl-6">
            <div class="title">
              创新与灵活性
            </div>
            <div class="desc">
              我们注重创新，并积极关注最新的技术趋势和行业动态。我们能够根据客户需求灵活调整开发策略，并提供具有竞争力的解决方案。
            </div>
          </li>
          <li class="col-xl-6 active active-bg03">
            <div class="title">
              完善的售后支持
            </div>
            <div class="desc">
              我们在项目交付后提供全面的售后支持和维护服务。如果客户在使用过程中遇到任何问题或需要进一步定制开发，我们将及时响应并提供支持，
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.advantage {
  width: 100%;
  height: 1442px;
  background: #fff;
}
.header {
  text-align: center;
  overflow: hidden;
  .header-title {
    font-size: 36px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #252930;
    margin: 120px 0 24px;
  }
  p {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #9fa3ac;
  }
}

.main {
  width: 100%;
  margin-top: 81px;
  position: relative;
  .row {
    width: 100%;
    li {
      height: 350px;
      text-align: left;
      .title {
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #252930;
        margin: 68px 0 49px 40px;
        position: relative;
      }
      .title::after {
        position: absolute;
        width: 275px;
        height: 2px;
        background: #56595f;
        content: "";
        top: 44px;
        left: 0;
      }
      .desc {
        width: 272px;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #9fa3ac;
        margin-left: 40px;
      }
    }
    .active {
      .title {
        color: #1966ff;
      }
      .title::after {
        background: #1966ff;
      }
      .desc {
        color: #56595f;
      }
    }
    .active-bg01 {
      background: url("../../assets/imgs/advantage-bg1.png") no-repeat;
      background-size: 100% 100%;
    }
    .active-bg02 {
      background: url("../../assets/imgs/advantage-bg2.png") no-repeat;
      background-size: 100% 100%;
    }
    .active-bg03 {
      background: url("../../assets/imgs/advantage-bg3.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
.main::before {
  position: absolute;
  content: "";
  height: 2px;
  border: 1px solid;
  border-image: linear-gradient(0deg, #d1d1d1, #fbfbfb, #d1d1d1) 10 10;
  background: linear-gradient(90deg, #d1d1d1 0%, #fbfbfb 50%, #d1d1d1 100%);
  width: 100%;
  top: 0;
  left: 0;
}
.main::after {
  position: absolute;
  content: "";
  height: 2px;
  border: 1px solid;
  border-image: linear-gradient(0deg, #d1d1d1, #fbfbfb, #d1d1d1) 10 10;
  background: linear-gradient(90deg, #d1d1d1 0%, #fbfbfb 50%, #d1d1d1 100%);
  width: 100%;
  bottom: 0;
  left: 0;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}
</style>
